import { RouteObject } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/auth/ProtectedRoute";

// Admin Pages
import AdminDashboard from "@/pages/admin/Dashboard";
import UserManagement from "@/pages/admin/users/UserManagement";
import VerificationManagement from "@/pages/admin/verification/VerificationManagement";
import RiskManagement from "@/pages/admin/risk/RiskManagement";
import FinancialManagement from "@/pages/admin/finance/FinancialManagement";
import VendorManagement from "@/pages/admin/vendors/VendorManagement";
import LenderManagement from "@/pages/admin/lenders/LenderManagement";
import Settings from "@/pages/admin/settings/Settings";
import CMSManagement from "@/pages/admin/cms/CMSManagement";

const adminRoutes: RouteObject[] = [
  {
    path: "/admin",
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <Layout><AdminDashboard /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/users/management",
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <Layout><UserManagement /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/cms",
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <Layout><CMSManagement /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/verification/management",
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <Layout><VerificationManagement /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/risk/management",
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <Layout><RiskManagement /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/finance",
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <Layout><FinancialManagement /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/lenders",
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <Layout><LenderManagement /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/vendors",
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <Layout><VendorManagement /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/settings",
    element: (
      <ProtectedRoute allowedRoles={['admin']}>
        <Layout><Settings /></Layout>
      </ProtectedRoute>
    ),
  },
];

export default adminRoutes;
